import React from 'react'
import { BackButtonDesktop } from './BackButton'

import { Logo } from './Logo'
import HeaderWrapper from './HeaderWrapper'

const BasicHeader = () => (
  <HeaderWrapper className='container-header-basic'>
    <Logo />
    <BackButtonDesktop />
    <div className='clear pl-1 order-md-3 order-3 d-flex d-md-none col-2' />
  </HeaderWrapper>
)

export default BasicHeader



// WEBPACK FOOTER //
// ./src/App/Header/BasicHeader.js